import { HttpLink, type Operation } from '@apollo/client';

const isMutation = (operation: Operation) =>
  operation.query.definitions.some(
    (node) =>
      node.kind === 'OperationDefinition' && node.operation === 'mutation'
  );

export const createHttpLink = ({
  uri,
  headers,
}: {
  uri: string;
  headers: Record<string, string>;
}) =>
  new HttpLink({
    uri: (operation) => {
      const urlInstance = new URL(uri);
      const context = operation.getContext();
      if (isMutation(operation) || context.fetchOptions?.method === 'POST') {
        // For POST requests, set operationName as a query parameter
        urlInstance.searchParams.set('operationName', operation.operationName);
      }
      if (
        operation.query.definitions.some(
          (node) =>
            node.kind === 'OperationDefinition' && node.operation === 'mutation'
        )
      ) {
        // For POST requests by mutations, set operationName as a query parameter
        urlInstance.searchParams.set('operationName', operation.operationName);
      }
      return urlInstance.href;
    },
    headers,
  });
